"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NetworkHealthData = void 0;
var _NetworkHealth = require("@studio/constants/NetworkHealth");
var _networkHealthUtil = require("./networkHealthUtil");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NetworkHealthData = exports.NetworkHealthData = /*#__PURE__*/function () {
  function NetworkHealthData() {
    _classCallCheck(this, NetworkHealthData);
    /**
     * Refer to https://wiki.cvent.com/display/STUDIO/A+Framework+For+Measuring+Reliability+in+Studio
     * to understand these metrics
     * NOTE: all of these metrics (except downlinkBandwidth) are upstream metrics
     */
    _defineProperty(this, "sampleCount", 0);
    _defineProperty(this, "uplinkBandwidth", 0);
    _defineProperty(this, "downlinkBandwidth", 0);
    _defineProperty(this, "audioPacketsSent", 0);
    _defineProperty(this, "audioPacketsLost", 0);
    _defineProperty(this, "audioJitter", 0);
    _defineProperty(this, "audioRTT", 0);
    _defineProperty(this, "videoSampleCount", 0);
    _defineProperty(this, "videoPacketsSent", 0);
    _defineProperty(this, "videoPacketsLost", 0);
    _defineProperty(this, "videoJitter", 0);
    _defineProperty(this, "videoRTT", 0);
    _defineProperty(this, "videoFrame", {});
  }
  return _createClass(NetworkHealthData, [{
    key: "getSampleCount",
    value: function getSampleCount() {
      return this.sampleCount;
    }

    /**
     * Register a metric sample for aggregation
     * Since we are mostly using average for aggregation, it simply adds the new metric values
     * except videoFrame where we simply use the last value
     */
  }, {
    key: "registerSample",
    value: function registerSample(metrics) {
      // Only update if we have audio metrics available
      // to ensure we don't register blank metrics samples
      var numAudioPacketsSent = parseInt(metrics.upstreamAudioPacketsSent);
      if (numAudioPacketsSent === 0) {
        return;
      }
      this.sampleCount++;
      this.uplinkBandwidth += parseInt(metrics.availableSendBandwidthKbps);
      this.downlinkBandwidth += parseInt(metrics.availableReceiveBandwidthKbps);
      this.audioPacketsSent += numAudioPacketsSent;
      var audioPacketLossPercentage = parseFloat(metrics.upstreamAudioPacketLoss);
      var numAudioPacketsLost = Math.floor(numAudioPacketsSent * audioPacketLossPercentage / 100);
      this.audioPacketsLost += numAudioPacketsLost;
      this.audioJitter += parseInt(metrics.upstreamAudioJitter);
      this.audioRTT += parseInt(metrics.upstreamAudioRoundTripTimeMs);
      if (metrics.upstreamVideoPacketsSent > 0) {
        this.videoSampleCount++;
        var numVideoPacketsSent = parseInt(metrics.upstreamVideoPacketsSent);
        var videoPacketLossPercentage = parseFloat(metrics.upstreamVideoPacketLoss);
        var numVideoPacketsLost = Math.floor(numVideoPacketsSent * videoPacketLossPercentage / 100);
        this.videoPacketsSent += numVideoPacketsSent;
        this.videoPacketsLost += numVideoPacketsLost;
        this.videoJitter += parseInt(metrics.upstreamVideoJitter);
        this.videoRTT += parseInt(metrics.upstreamVideoRoundTripTimeMs);
        this.videoFrame = {
          fps: parseInt(metrics.upstreamVideoFPS),
          width: parseInt(metrics.upstreamVideoFrameWidth),
          height: parseInt(metrics.upstreamVideoFrameHeight)
        };
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.sampleCount = 0;
      this.uplinkBandwidth = 0;
      this.downlinkBandwidth = 0;
      this.audioPacketsSent = 0;
      this.audioPacketsLost = 0;
      this.audioJitter = 0;
      this.audioRTT = 0;
      this.videoSampleCount = 0;
      this.videoPacketsSent = 0;
      this.videoPacketsLost = 0;
      this.videoJitter = 0;
      this.videoRTT = 0;
      this.videoFrame = {};
    }

    /**
     * Aggregate the metrics received so far and create the network health payload
     */
  }, {
    key: "getNetworkHealthDataPayload",
    value: function getNetworkHealthDataPayload(meetingSession) {
      var networkHealthDataPayload = {};
      if (this.sampleCount === 0) {
        return networkHealthDataPayload;
      }
      var estimatedUplinkBandwidth = this.uplinkBandwidth / this.sampleCount;
      networkHealthDataPayload.estimatedUplinkBandwidth = estimatedUplinkBandwidth ? estimatedUplinkBandwidth.toFixed(0) : 0;
      var estimatedDownlinkBandwidth = this.downlinkBandwidth / this.sampleCount;
      networkHealthDataPayload.estimatedDownlinkBandwidth = estimatedDownlinkBandwidth ? estimatedDownlinkBandwidth.toFixed(0) : 0;
      var audioPacketLoss = this.audioPacketsLost / this.audioPacketsSent * 100;
      networkHealthDataPayload.audioPacketLoss = audioPacketLoss ? Math.round(audioPacketLoss * 100) / 100 : 0;
      var audioJitter = this.audioJitter / this.sampleCount;
      networkHealthDataPayload.audioJitter = audioJitter ? audioJitter.toFixed(0) : 0;
      var audioRTT = this.audioRTT / this.sampleCount;
      networkHealthDataPayload.audioLatency = audioRTT ? audioRTT.toFixed(0) : 0;
      var audioMOS = this.computeMOS(audioPacketLoss, audioJitter, audioRTT);
      networkHealthDataPayload.audioMOS = Math.round(audioMOS * 100) / 100;
      if (this.videoSampleCount > 0) {
        var videoPacketLoss = this.videoPacketsLost / this.videoPacketsSent * 100;
        networkHealthDataPayload.videoPacketLoss = videoPacketLoss ? Math.round(videoPacketLoss * 100) / 100 : 0;
        var videoJitter = this.videoJitter / this.videoSampleCount;
        networkHealthDataPayload.videoJitter = videoJitter ? videoJitter.toFixed(0) : 0;
        var videoRTT = this.videoRTT / this.videoSampleCount;
        networkHealthDataPayload.videoLatency = videoRTT ? videoRTT.toFixed(0) : 0;
        var videoMOS = this.computeMOS(videoPacketLoss, videoJitter, videoRTT);
        networkHealthDataPayload.videoMOS = Math.round(videoMOS * 100) / 100;
        networkHealthDataPayload.videoFrame = this.getVideoFrameDisplayData();
        networkHealthDataPayload.videoFrameHeight = this.videoFrame.height;
        networkHealthDataPayload.networkQuality = this.getNetworkQuality(videoMOS, this.videoFrame.height, (0, _networkHealthUtil.getExpectedResolutionHeight)(meetingSession));
      } else {
        networkHealthDataPayload.videoPacketLoss = 'NA';
        networkHealthDataPayload.videoJitter = 'NA';
        networkHealthDataPayload.videoLatency = 'NA';
        networkHealthDataPayload.videoNetworkQualityScore = 'NA';
        networkHealthDataPayload.videoFrame = 'NA';
        networkHealthDataPayload.networkQuality = 'NA';
      }
      return networkHealthDataPayload;
    }
  }, {
    key: "getVideoFrameDisplayData",
    value: function getVideoFrameDisplayData() {
      return this.videoFrame.width + 'x' + this.videoFrame.height + ', ' + this.videoFrame.fps + 'fps';
    }

    /**
     * MOS (Mean Opinion Score) is used to quantify the audio/video quality
     * We are using the algorithm from webrtc-issue-detector library
     * https://github.com/VLprojects/webrtc-issue-detector/blob/master/src/NetworkScoresCalculator.ts#L145
     */
  }, {
    key: "computeMOS",
    value: function computeMOS(packetLoss, jitter, RTT) {
      if (!packetLoss) {
        packetLoss = 0;
      }
      if (!jitter) {
        jitter = 0;
      }
      if (!RTT) {
        RTT = 0;
      }
      var effectiveLatency = RTT + jitter * 2 + 10;
      var rFactor = 93.2 - effectiveLatency / 40;
      if (effectiveLatency >= 160) {
        rFactor = 93.2 - effectiveLatency / 120 - 10;
      }
      rFactor -= packetLoss * 2.5;
      if (rFactor < 0) {
        rFactor = 0;
      }
      var MOSScore = 1 + 0.035 * rFactor + 0.000007 * rFactor * (rFactor - 60) * (100 - rFactor);
      return MOSScore;
    }

    /**
     * https://wiki.cvent.com/display/STUDIO/Network+Health+Indicator (Section FAQ -> #3)
     * For more details on the algorithm for computing network quality
     * based on upstream video MOS and upstream video resolution
     */
  }, {
    key: "getNetworkQuality",
    value: function getNetworkQuality(MOS, resolutionFrameHeight, expectedResolutionFrameHeight) {
      var scoreQualityMap = {
        1: _NetworkHealth.NETWORK_HEALTH_POOR,
        2: _NetworkHealth.NETWORK_HEALTH_GOOD,
        3: _NetworkHealth.NETWORK_HEALTH_EXCELLENT
      };
      var MOSBasedScore = 1;
      if (MOS >= 4) {
        MOSBasedScore = 3;
      } else if (MOS >= 3) {
        MOSBasedScore = 2;
      }
      if (expectedResolutionFrameHeight) {
        var resolutionBasedScore = 1;
        if (resolutionFrameHeight === expectedResolutionFrameHeight || resolutionFrameHeight === 480) {
          resolutionBasedScore = 3;
        } else if (resolutionFrameHeight < expectedResolutionFrameHeight && resolutionFrameHeight > 480) {
          resolutionBasedScore = 2;
        }
        var finalScore = Math.min(MOSBasedScore, resolutionBasedScore);
        return scoreQualityMap[finalScore];
      } else {
        return scoreQualityMap[MOSBasedScore];
      }
    }
  }]);
}();